import React, { createContext, useContext, useState } from "react";

interface Coordinate {
  lng: number;
  lat: number;
  label?: string;
  address: string;
  churchId: string;
}

interface ChurchesContextType {
  locations: Coordinate[];
  setLocations: (locs: Coordinate[]) => void;
}

const ChurchesContext = createContext<ChurchesContextType | null>(null);

export const useChurches = () => {
  const context = useContext(ChurchesContext);
  if (!context) throw new Error("Must be used within ChurchesProvider");
  return context;
};

export const ChurchesProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [locations, setLocations] = useState<Coordinate[]>([]);
  return (
    <ChurchesContext.Provider value={{ locations, setLocations }}>
      {children}
    </ChurchesContext.Provider>
  );
};
